import { z } from 'zod'

export const SearchGlobalQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    lot: z.array(
        z.object({
            __typename: z.literal('lot').optional(),
            id: z.string(),
            name: z.string().nullish(),
            address: z.string().nullish()
        })
    ),
    station: z.array(
        z.object({
            __typename: z.literal('station').optional(),
            station_name: z.string(),
            device_uuid: z.string().nullish()
        })
    ),
    device: z.array(
        z.object({
            __typename: z.literal('device').optional(),
            uuid: z.string(),
            device_name: z.string().nullish(),
            type: z.string().nullish()
        })
    )
})

export type SearchGlobalQuery = z.infer<typeof SearchGlobalQuerySchema>
